import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ClearanceItemService } from './clearance-item.service';
import { ItemHistory, ClearanceItem } from './clearance-item.model';
import { GlobalErrorHandler } from '../shared/core/error-handler';

@Component({
    selector: 'clearance-item-history',
    standalone: false,
    templateUrl: './clearance-item-history.component.html',
    styleUrls: ['./clearance-item-history.component.css'],
})

export class ClearanceItemHistoryComponent implements OnInit {

    onHistoryRetrieved(history: ItemHistory[]): any {
        // console.log('history:' + JSON.stringify(history));
        if (history.length == 0) {
            this.historyLabel = 'No history was found';// for item: " + this.item.name;
        }
        this.history = history;
        this._cdr.detectChanges();
    }

    constructor(private route: ActivatedRoute,
        private router: Router,
        private itemService: ClearanceItemService,
        private _location: Location,
        private _errorHandler: GlobalErrorHandler,
        private _cdr: ChangeDetectorRef
    ) {
        itemService.CurrrentClearanceItem.subscribe(i => {
            this.item = i;
        });
    }

    itemId: string;
    history: ItemHistory[] = [];
    item: ClearanceItem;
    historyLabel: string = '';

    ngOnInit(): void {


        // // Read the clearance Id from the route parameter
        this.route.params.subscribe(
            params => {
                let id = params['ciId'];
                this.itemId = id;
                if (id) {
                    this.getHistory(id);
                }
            }
        );
    }

    closeHistory() {
        this._location.back();
    }
    getHistory(id: string): void {
        // this.showSpinner = true;
        this.itemService.getHistory(id)
            .subscribe({
                next: (data) => {
                    this.onHistoryRetrieved(data);
                },
                error: (error: any) => {
                    this.historyLabel = 'No history was found';
                    this._cdr.detectChanges();
                    this._errorHandler.processError(error);
                }
            });

    }

}